export default "__VITE_ASSET__JHpI$ry3__"